import produce from "immer";
import { LoadState } from "../../constants/enums";
import { IStoreState } from "../initialStoreState";
import { PromocodeActions } from "./index";
import {
  CLEAR_PROMOCODE,
  CLEAR_PROMOCODE_STATE,
  FETCH_PROMOCODE_FAILED,
  FETCH_PROMOCODE_LIST_FAILED,
  FETCH_PROMOCODE_LIST_PROGRESS,
  FETCH_PROMOCODE_LIST_SUCCESS,
  FETCH_PROMOCODE_PROGRESS,
  FETCH_PROMOCODE_SUCCESS,
} from "./promocode.action";
import { initialPromocodeState } from "./promocode.state";

export const promocodeReducer = (
  state: IStoreState["promocode"] = initialPromocodeState,
  action: PromocodeActions
) => {
  switch (action.type) {
    case FETCH_PROMOCODE_LIST_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.promocode.list.loading = LoadState.InProgress;
        draftState.promocode.list.list = [];
        draftState.promocode.list.totalRecords = 0;
      });
      return newState;
    }
    case FETCH_PROMOCODE_LIST_SUCCESS: {
      const { list, totalRecords } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.promocode.list.loading = LoadState.Loaded;
        draftState.promocode.list.list = list;
        draftState.promocode.list.totalRecords = totalRecords;
      });
      return newState;
    }
    case FETCH_PROMOCODE_LIST_FAILED: {
      const newState = produce(state, (draftState) => {
        draftState.promocode.list.loading = LoadState.Failed;
        draftState.promocode.list.list = [];
        draftState.promocode.list.totalRecords = 0;
      });
      return newState;
    }
    case FETCH_PROMOCODE_PROGRESS: {
      const newState = produce(state, (draftState) => {
        draftState.promocode.data.loading = LoadState.InProgress;
        draftState.promocode.data.data = null;
      });
      return newState;
    }
    case FETCH_PROMOCODE_SUCCESS: {
      const { promocode } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.promocode.data.loading = LoadState.Loaded;
        draftState.promocode.data.data = promocode;
      });
      return newState;
    }
    case FETCH_PROMOCODE_FAILED: {
      const { errorMessage } = action.payload;
      const newState = produce(state, (draftState) => {
        draftState.promocode.data.loading = LoadState.Failed;
        draftState.promocode.data.error = errorMessage;
      });
      return newState;
    }
    case CLEAR_PROMOCODE: {
      const newState = produce(state, (draftState) => {
        draftState.promocode.data.loading = LoadState.NotLoaded;
        draftState.promocode.data.data = null;
      });
      return newState;
    }
    case CLEAR_PROMOCODE_STATE: {
      const newState = produce(state, (draftState) => {
        draftState.promocode = initialPromocodeState.promocode;
      });
      return newState;
    }
    default: {
      return state;
    }
  }
};
